import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Garnir = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Другi страви'/>
            <main className={s.main}>
                <Product name='Картопля по-селянські' price='50 грн.' weight='250г.'/>
                <Product name='Рис з овочами' price='55 грн.' weight='200г.'/>
                <Product name='Картопляне пюре з курячою відбивною' price='110 грн.' weight='300г.'/>
                <Product name='Каша гречана з куркою у вершковому соусі' price='110 грн.' weight='450г.'/>
                <Product name='Млинці з куркою та грибами' price='110 грн.' weight='250г.'/>
                <Product name='Пельмені зі сметаною' price='70 грн.' weight='250г.'/>
                <Product name='Деруни зі сметаною' price='80 грн.' weight='250.'/>
                <Product name='Деруни з грибною поливкою' price='95 грн.' weight='280.'/>
            </main>
        </div>
    )
}

export default Garnir;